import { connect } from 'react-redux'
import ProductListViewSellersStore from './ProductListViewSellersStore'
import { getState, getDispatch } from 'x/modules/productlist/ProductListViewConnect'

export default connect(
  (state) => getState(state),
  (dispatch) => getDispatch(dispatch)
)(ProductListViewSellersStore)
